/* eslint-disable max-len */
import { memo } from 'react';

export interface IIconProps {
  fill?: string;
}

function HeartIcon({ fill = 'white' }: IIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="172"
      height="143"
      viewBox="0 0 172 143"
      fill="none"
    >
      <g clipPath="url(#clip0_3879_24939)">
        <rect
          width="170.4"
          height="142"
          transform="matrix(-1 0 0 1 171.203 0.5)"
          fill={fill}
        />
        <ellipse
          cx="58.0441"
          cy="56.9322"
          rx="58.0441"
          ry="56.9322"
          transform="matrix(0.998578 -0.0533131 0.217268 0.976112 -1.71094 21.0078)"
          fill="#7EFBB1"
        />
        <path
          d="M90.2177 41.7938L86.4813 49.1773L79.9514 44.0943C72.8604 38.5746 64.7727 36.7013 59.448 36.7013C47.2268 36.7013 37.8038 46.1392 37.8038 57.1964C37.8038 68.0651 45.0569 77.43 56.1997 85.1074C66.549 92.2382 79.0221 97.0025 87.8691 99.3187C97.7478 96.6258 111.781 91.0259 123.438 82.592C135.84 73.6201 144.334 62.3921 144.334 49.0034C144.334 41.6647 142.043 35.7124 138.306 31.4184C134.575 27.1313 129.066 24.108 121.919 23.2047C112.166 21.9722 97.2041 27.9876 90.2177 41.7938Z"
          fill={fill}
          stroke="#1D1D1D"
          strokeWidth="13.6292"
        />
      </g>
      <defs>
        <clipPath id="clip0_3879_24939">
          <rect
            width="170.4"
            height="142"
            fill={fill}
            transform="matrix(-1 0 0 1 171.203 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
    // <svg
    //   width="81"
    //   height="80"
    //   viewBox="0 0 81 80"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     fillRule="evenodd"
    //     clipRule="evenodd"
    //     d="M40.9821 16.8018C47.965 11.6487 57.8459 12.2394 64.1644 18.574C71.1295 25.5569 71.1295 36.8784 64.1645 43.8637L42.0734 66.0148C41.2051 66.8854 39.7949 66.8855 38.9265 66.0149L16.833 43.8635C9.86813 36.8784 9.86813 25.5569 16.8332 18.574C23.1517 12.2394 33.0327 11.6487 40.0172 16.8018L40.4997 17.1706L40.9821 16.8018ZM61.0174 40.7254C66.2526 35.475 66.2526 26.9609 61.0177 21.7127C55.786 16.4677 47.305 16.4677 42.0733 21.7127C41.2051 22.5831 39.7952 22.5832 38.9269 21.713C33.6929 16.4676 25.2117 16.4676 19.9799 21.7127C14.7451 26.9609 14.7451 35.475 19.98 40.7252L40.4999 61.2987L61.0174 40.7254ZM48.7394 48.2363L59.1394 37.8096C60.0061 36.9407 60.0043 35.5337 59.1354 34.6669C58.2664 33.8002 56.8594 33.802 55.9927 34.671L45.5927 45.0976C44.7259 45.9666 44.7277 47.3736 45.5967 48.2403C46.4656 49.107 47.8727 49.1052 48.7394 48.2363Z"
    //     fill={fill || '#FF8000'}
    //   />
    // </svg>
  );
}

export default memo(HeartIcon);
